import { createClient } from '@supabase/supabase-js';

const REMOTE_SUPABASE_URL = 'https://boxxsylreosmaldzfqor.supabase.co';
const REMOTE_SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJveHhzeWxyZW9zbWFsZHpmcW9yIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgxMjk5OTksImV4cCI6MjA4MzcwNTk5OX0.P2eK7rwdWSWsbFPWSi9TUKnHGi46-1g7oTFw4RpwA1M';

export const remoteSupabase = createClient(REMOTE_SUPABASE_URL, REMOTE_SUPABASE_ANON_KEY);
